module.exports = __webpack_public_path__ + "img/icon_arrow01.c7f1a998.svg";